import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  permitId: string;
  orderId: string;
}

export const useApplyLastChangesToPermitApplication = ({
  permitId,
  orderId,
}: Props) => {
  const { mutateAsync: applyLastChangesToPermitApplication } = useMutation({
    mutationFn: () =>
      OrdersClient.applyLastChangesToPermitApplication(orderId, permitId),
  });

  return {
    applyLastChangesToPermitApplication,
  };
};
